// src/das-application/application-steps/StepContent2.js
import React, { memo } from "react";

import Grid from "@mui/material/Grid";

import FormRow from "../../helpers/FormRow";
import FormInput from "../../helpers/FormInput";
import FormRadioGroup from "../../helpers/FormRadioGroup";

function StepContent2({
  formData,
  setFormData,
  stepErrors,
  handleChange,
  isReadOnly,
  appID,
}) {
  const getStatus = (field, isRequired) => {
    if (stepErrors[field]) {
      return "error";
    }
    if (isRequired && (formData[field] === true || formData[field] === false)) {
      return "success";
    }
    if (!isRequired && !formData[field]) {
      return "warning";
    }
    return "";
  };

  return (
    <div className="form-group">
      <h3 className="bold-text">Career & Post-Secondary Plans:</h3>
      <FormRow spacing={2}>
        <Grid item xs={12}>
          <FormRadioGroup
            label="Are you planning on attending Post Secondary next year?"
            name="direct_to_post_secondary"
            value={formData.direct_to_post_secondary ? "Yes" : "No"}
            onChange={handleChange("direct_to_post_secondary")}
            options={[
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ]}
            row
            required
            isReadOnly={isReadOnly}
            error={Boolean(stepErrors.direct_to_post_secondary)}
            helperText={stepErrors.direct_to_post_secondary || ""}
            status={getStatus("direct_to_post_secondary", true)}
          />
        </Grid>
      </FormRow>

      <FormRow spacing={2}>
        <Grid item xs={12}>
          <FormInput
            label="For which post-secondary program(s) do you plan to apply for?"
            id="programs_applying_for"
            value={formData.programs_applying_for}
            onChange={handleChange("programs_applying_for")}
            multiline
            rows={4}
            required
            disabled={isReadOnly}
            error={Boolean(stepErrors.programs_applying_for)}
            helperText={stepErrors.programs_applying_for || ""}
            status={getStatus("programs_applying_for", true)}
          />
        </Grid>
      </FormRow>
      <FormRow spacing={2}>
        <Grid item xs={12}>
          <FormInput
            label="What are your long term career plans?"
            id="long_term_career_plans"
            value={formData.long_term_career_plans}
            onChange={handleChange("long_term_career_plans")}
            multiline
            rows={4}
            required
            disabled={isReadOnly}
            error={Boolean(stepErrors.long_term_career_plans)}
            helperText={stepErrors.long_term_career_plans || ""}
            status={getStatus("long_term_career_plans", true)}
          />
        </Grid>
      </FormRow>
      <h4 className="bold-text">
        The District/Authority scholarship recognizes high school graduates who
        have demonstrated excellence in their chosen area, within one of the
        following categories (Please tick only one area):
      </h4>

      <FormRow spacing={2}>
        <Grid item xs={12}>
          <FormRadioGroup
            label="Scholarship Category"
            name="scholarship_category"
            value={formData.scholarship_category}
            onChange={handleChange("scholarship_category")}
            options={[
              {
                value: "APLSK",
                label:
                  "APLSK: Applied Design, Skills, and Technologies (e.g., Business, Technology, Home Economics, Media Arts, Tourism)",
              },
              {
                value: "COMSERV",
                label:
                  "COMSERV: Community Service (Volunteer Activity), which includes awareness of local, global, and cultural issues",
              },
              {
                value: "FINE",
                label:
                  "FINE: Fine Arts (e.g., Dance, Drama, Music, Visual Arts)",
              },
              {
                value: "INDLC",
                label:
                  "INDLC: Indigenous Languages and Culture, demonstrated at school or in the community",
              },
              {
                value: "LNG",
                label:
                  "LNG: Languages from the Languages Curriculum or External Assessments, including AP and IB courses",
              },
              {
                value: "PHYSAC",
                label:
                  "PHYSAC: Physical Activity (and Health) (e.g., Athletics, Dance, Gymnastics)",
              },
              {
                value: "TRADES",
                label:
                  "TRADES: Technical and Trades Training (e.g., Coding, Culinary Arts, Mechanics, Robotics, Woodwork)",
              },
            ]}
            required
            column
            isReadOnly={isReadOnly}
            error={Boolean(stepErrors.scholarship_category)}
            helperText={stepErrors.scholarship_category || ""}
            status={getStatus("scholarship_category", true)}
          />
        </Grid>
      </FormRow>
    </div>
  );
}

export default memo(StepContent2);
